import { css, SerializedStyles } from "@emotion/react";
import { BORDER_RADIUS_SMALL } from "../../../common-styles/borders";

export const button_preloader: SerializedStyles = css({
    height: '100%',
    width: '100%',
    borderRadius: BORDER_RADIUS_SMALL,
});
